import src from "IMAGE";
export default { src, width: 1228, height: 682, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAIAAAA8r+mnAAAANElEQVR42nXJuwoAIAxD0c469DEmUP//Ly0KQgfPEsKV8SF3IiLLSndvwcwAkFTVFso83t34IQTxpQpQpwAAAABJRU5ErkJggg=="};
